const SELECTOR = ".info-cards a[data-scroll-anchor]";

const prefersReducedMotion = (): boolean =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const scrollToSection = (section: HTMLElement): void => {
  section.scrollIntoView({
    behavior: prefersReducedMotion() ? "auto" : "smooth",
    block: "start",
  });

  if (!section.hasAttribute("tabindex")) {
    section.setAttribute("tabindex", "-1");
  }

  section.focus({ preventScroll: true });
};

const clickHandler = (event: MouseEvent): void => {
  if (event.defaultPrevented || event.button !== 0) return;

  const eventTarget = event.target;
  if (!(eventTarget instanceof Element)) return;

  const trigger = eventTarget.closest<HTMLAnchorElement>(SELECTOR);
  if (!trigger) return;

  const id = trigger.hash.slice(1);
  if (!id) return;

  const section = document.getElementById(id);
  if (!section) return;

  event.preventDefault();
  scrollToSection(section);
  history.replaceState(null, "", trigger.hash);
};

document.addEventListener("click", clickHandler);
